<template>
  <span class="text-danger" v-if="validationErrors.some(x => x.key.includes(validKey, validationErrors))">{{$errorMessage(validKey, validationErrors)}}</span>
</template>

<script>
  export default {
    props:['validKey'],
    name: "QuestionValidation",
    computed:{
        validationErrors(){
            return this.$store.getters.getParticipantValidation;
        },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/QuestionValidation.vue